import { TAxisOptions } from '../types/types';
import { colors } from '../styles/color';

const xAxis: TAxisOptions = {
  title: {
    text: '',
  },
  visible: true,
  type: 'datetime',
  lineWidth: 1,
  lineColor: colors.lightGrey,
  labels: {
    enabled: true,
  },
  showFirstLabel: true,
  showLastLabel: true,
  startOnTick: false,
  tickInterval: 1,
  tickLength: 5,
  plotBands: [{
    color: colors.red,
    borderColor: colors.white,
    borderWidth: 10,
    opacity: 35,
  }],
};

const yAxis: TAxisOptions = {
  title: {
    text: '',
  },
  gridLineDashStyle: 'Dash',
  visible: true,
  showFirstLabel: true,
  showLastLabel: true,
  opposite: false,
  min: undefined,
  max: undefined,
  tickInterval: undefined,
};

export const staticChartStyleOption = {
  title: {
    text: null,
  },
  xAxis,
  yAxis,
  tooltip: {
    crosshairs: [{
      width: 1,
      color: colors.lightGrey,
      dashStyle: 'Dash',
    }],
    backgroundColor: colors.white,
    borderWidth: 4,
    borderColor: colors.white,
    useHTML: true,
    shared: true,
    shadow: false,
    valueDecimals: 2,
  },
  chart: {
    spacingTop: 0,
    spacingLeft: 0,
    spacingRight: 0,
    spacingBottom: 0,
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    line: {
      states: {
        hover: {
          enabled: true,
          halo: {
            size: 0,
          },
        },
      },
    },
  },
};
